import { render, staticRenderFns } from "./Info_School.vue?vue&type=template&id=ba133a08&scoped=true"
import script from "./Info_School.vue?vue&type=script&lang=js"
export * from "./Info_School.vue?vue&type=script&lang=js"
import style0 from "./Info_School.vue?vue&type=style&index=0&id=ba133a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba133a08",
  null
  
)

export default component.exports